'use client'

import { Icon } from '@/components/icons/Icon'
import { usePage } from '@/components/providers/PageProvider'
import { isIconType } from '@/defs/icon'
import { COLOR_ID_LABELS } from '@/defs/mtg'

import { renderTemplate } from './renderTemplate'

type Props = {
  children: string
}

export const ParsedTemplate = ({ children }: Props) => {
  const { page } = usePage()
  const route = page?.route

  return renderTemplate(children, (type, value) => {
    if (type === 'icon') {
      if (value === 'colorId') {
        return route?.colorId ? <Icon name={COLOR_ID_LABELS[route.colorId].icon} /> : null
      }
      if (value?.includes('colorId')) {
        if (!route?.colorId) return null
        const [before, after] = value.split('colorId')
        return (
          <>
            {before}
            <Icon name={COLOR_ID_LABELS[route.colorId].icon} />
            {after}
          </>
        )
      }
      return isIconType(value) && <Icon name={value} />
    }
    return value
  })
}
